import { Container, Row, Col } from "react-bootstrap";
import { User } from "lucide-react"; // simple user icons
import "./AboutUs.css";

function AboutUs() {
  return (
    <div className="about-page">
      {/* Story Section */}
      <section className="about-narrative">
        <Container>
          <h1 className="fw-bold text-center story-title">Historia Jonë</h1>
          <p className="lead text-center story-sub">
            "Freski nga natyra, autenticitet në çdo gotë."
          </p>

          <div className="story-text">
            <p>
              Probioma lindi nga dëshira për të sjellë pije natyrale dhe artizanale 
              që mbështesin shëndetin dhe mirëqenien. Nga Kombucha tek Klorofili, 
              Spirulina dhe Ginger Beer, çdo produkt është prodhuar me përkushtim 
              dhe kujdes për cilësinë.
            </p>

            <p>
              Besojmë se një stil jete i shëndetshëm ndërtohet nga zgjedhje të vogla 
              të përditshme. Për këtë arsye, ne përdorim përbërës lokalë, organikë 
              dhe prodhojmë në sasi të vogla për të garantuar freski dhe autenticitet.
            </p>

            <p>
              Çdo gotë Probioma është një histori bashkëpunimi midis natyrës dhe 
              pasionit tonë për shëndet. Misioni ynë është i thjeshtë:{" "}
              <strong>Të sjellim produkte të freskëta, lokale dhe organike për një jetë më të mirë.</strong>
            </p>
          </div>
        </Container>
      </section>

      {/* Meet the Founders */}
      <section className="founders">
        <Container>
          <h2 className="text-center section-title mb-5">
            Takoni Bashkëthemeluesit
          </h2>
          <Row className="justify-content-center g-4">
            <Col md={4} className="text-center">
              <div className="founder-icon">
                <User size={70} />
              </div>
              <h5 className="mt-3">Alkend Cuko</h5>
              <p className="founder-text">
                Sipërmarrës dhe inxhinier sistemi me pasion për jetesën e shëndetshme 
                dhe inovacionin. Alkend sjell vizionin për të lidhur traditën me teknologjinë, 
                duke e bërë Probioma një markë të besueshme.
              </p>
            </Col>
            <Col md={4} className="text-center">
              <div className="founder-icon">
                <User size={70} />
              </div>
              <h5 className="mt-3">Hyrrida Basha</h5>
              <p className="founder-text">
                Edukator dhe i apasionuar pas artizanatit, Hyrrida kujdeset që çdo produkt
                i Probioma të jetë i balancuar midis shijes natyrale dhe vlerave ushqyese.
                Ai sjell autenticitet dhe fokus mbi cilësinë.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Closing Quote */}
      <section className="stoic-quote text-center">
        <Container>
          <blockquote className="blockquote">
            <q className="stoic-text">
              "Shëndeti është thesari më i madh që mund të zotërojmë. Nga natyra, lind forca jonë."
            </q>
            <footer className="stoic-author">
              — Probioma
            </footer>
          </blockquote>
        </Container>
      </section>
    </div>
  );
}

export default AboutUs;
